import React, { FC, useEffect } from 'react';
import { useCurrentCategoryValue, useViewport, initUserDsInsights, useMsIdAtomValue } from '../../context';
import { OneColumnLayout } from '../../components/layouts';
import { MobileStoreName } from './MobileStoreName/MobileStoreName';
import { StoreName } from './StoreName/StoreName';
import { useStoreSuggestions } from './hooks/useStoreSuggestions';
import { resetStoreNameData, useStoreNameData } from './context/storeNameAtoms';
import { useStorePayments } from './hooks/useStorePayments';
import { Box, Loader } from '@wix/design-system';
import { useSpec } from '../../hooks/useSpec';
import { SelectThemeFirst } from '../../experiments';
import { LoadingGridWrapper } from '../templateSelection/components/ProductLoadingGrid/LoadingGridWrapper';
import { useProductsLoadingComplete } from '../templateSelection/context/templateContext';

export interface StoreNameWrapperProps {}

export const StoreNameWrapper: FC<StoreNameWrapperProps> = () => {
  const { isMobile } = useViewport();
  const { getStoreNameSuggestions } = useStoreSuggestions();
  const { handleShowAcceptPayments } = useStorePayments();
  const { isLoadingAggregators } = useStoreNameData();
  const msId = useMsIdAtomValue();
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);
  const isProductsLoadingComplete = useProductsLoadingComplete();
  const currentCategoryValue = useCurrentCategoryValue();

  useEffect(() => {
    const init = async () => {
      if (!msId) {
        return;
      }

      await initUserDsInsights();
      await Promise.all([getStoreNameSuggestions(), handleShowAcceptPayments()]);
    };

    void init();

    return () => {
      resetStoreNameData();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msId]);

  if (!currentCategoryValue) {
    return;
  }

  if (shouldSelectThemeFirst && (!msId || !isProductsLoadingComplete)) {
    return <LoadingGridWrapper category={currentCategoryValue} />;
  }

  if (isLoadingAggregators) {
    return (
      <Box align="center" verticalAlign="middle" height="100%" width="100%">
        <Loader size="large" />
      </Box>
    );
  }

  if (isMobile) {
    return <OneColumnLayout content={<MobileStoreName />} />;
  }

  return <StoreName />;
};
